import type { IconProps } from './types';

function CrosshairIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M12 19.4999C16.1422 19.4999 19.5 16.1421 19.5 11.9999M12 19.4999C7.85786 19.4999 4.5 16.1421 4.5 11.9999M12 19.4999V23.2499M19.5 11.9999C19.5 7.85778 16.1422 4.49991 12 4.49991M19.5 11.9999H23.25M12 4.49991C7.85786 4.49991 4.5 7.85778 4.5 11.9999M12 4.49991V0.75M4.5 11.9999H0.75"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { CrosshairIcon };
